import { useCallback } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { user } from 'services';
import { Submit, ButtonContainer } from 'libs/ui';
import { StyledField, required, ErrorMsg, isPhone, isEmail } from 'libs/form';

const ContactFormForm = (props) => {
  const { t } = useTranslation();
  const { handleSubmit, error, submitting } = props;
  const rightUpdate = user.haveRight('clients.update');

  const requiredField = useCallback(required(t), [t]);
  const isEmailR = useCallback(isEmail(t), [t]);
  const isPhoneR = useCallback(isPhone(t, true), [t]);
  const isPhoneNR = useCallback(isPhone(t), [t]);

  return (
    <form onSubmit={handleSubmit}>
      <ErrorMsg theme="dark" message={error} />

      <StyledField validate={requiredField} type="text" label={t('form.ФИО') + config.req} name="name" placeholder={t('form.Иванов Иван Иванович')} />
      <StyledField type="text" label={t('grid.Телефон') + config.req} name="tel_num" placeholder={t('grid.+7 (999) 999-99-99')} mask="+9(999)9999999" validate={isPhoneR} />
      <StyledField type="text" label={t('grid.Доп.телефон')} name="tel_num_2" placeholder={t('grid.+7 (999) 999-99-99')} validate={isPhoneNR} naturalNumber />
      <StyledField type="text" label={t('form.E-mail')} name="email" placeholder={t('form.E-mail')} validate={isEmailR} />
      <StyledField type="text" label={t('form.Доп. email')} name="email_2" placeholder={t('form.E-mail')} validate={isEmailR} />
      <StyledField type="text" label={t('form.Веб-сайт')} name="website" placeholder={t('form.Веб-сайт')} />
      <StyledField type="text" label={t('form.Адрес')} name="address" placeholder="г. Санкт-Петербург, Загородный проспект 26, кв 43" />
      {rightUpdate && (
        <ButtonContainer>
          <Submit disabled={submitting} />
        </ButtonContainer>
      )}
    </form>
  );
};

export const ContactForm = reduxForm({
  form: 'contactForm',
})(ContactFormForm);
